import { render, staticRenderFns } from "./OptionsPriceType.vue?vue&type=template&id=2da82842&"
import script from "./OptionsPriceType.vue?vue&type=script&lang=js&"
export * from "./OptionsPriceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports